//===============================================================
// DEVICE TYPE
//===============================================================
const ua = window.navigator.userAgent.toLowerCase();

// Device判定
function getDeviceType(){
	let type = "";
	if(0 <= ua.indexOf("android")){
		type += 'android';
		if(ua.indexOf("mobile") == -1)
			type += 'tablet';
	}else if( (ua.indexOf("applewebkit") > -1 && ua.indexOf("mobile") > -1)){
		type += 'iphone';
		if(0 <= ua.indexOf("ipad"))
			type = 'ipad';
	}else
		type = 'pc';
	
	return type;
	
}

export {getDeviceType}